import { useLayoutEffect } from 'react';

import { forwardRef, StyleProps } from '@bonusly/design-system';

import { useRichText } from './hooks/use-rich-text';
import { StyledEditor } from './styled-editor';

interface RichTextDisplayProps extends StyleProps {
	children?: string;
}

export const RichTextDisplay = forwardRef<RichTextDisplayProps, 'div'>(({ children, ...rest }, ref) => {
	const { editor } = useRichText({
		content: children,
		editable: false,
		editorProps: {
			attributes: {
				// Remove the default textbox role since this is display-only content, not an input
				role: 'none',
			},
		},
	});

	useLayoutEffect(() => {
		if (editor && children) {
			editor.commands.setContent(children);
		}
	}, [children]);

	return <StyledEditor editor={editor} ref={ref} {...rest} />;
});
